module.exports = __webpack_public_path__ + "static/media/timer.b328faa3.mp3";